export default "<m-image\n    src=\"https://public.mml.io/test-image.jpg\"\n    y=\"2\"\n    width=\"5\"\n></m-image>\n";